import { render, staticRenderFns } from "./DetailsLieferung.vue?vue&type=template&id=23295a2e&scoped=true"
import script from "./DetailsLieferung.vue?vue&type=script&lang=ts"
export * from "./DetailsLieferung.vue?vue&type=script&lang=ts"
import style0 from "./DetailsLieferung.vue?vue&type=style&index=0&id=23295a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23295a2e",
  null
  
)

export default component.exports